import { useOrgs } from "~/hooks";

export const useCurrentLocation = () => {
  const { getOrgLocation } = useOrgs();
  return getOrgLocation();
};
